import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDBodyText, FDHeadlineText } from '@facet-wealth/design';

export default buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDHeadlineText,
    _customProps: {
      align: 'center',
      size: 'sm',
      color: 'textSecondary',
    },
  }, overrideReadOnly)
  .nameOverride('description', {
    _component: () => FDBodyText,
    _customProps: {
      align: 'center',
    },
  }, overrideReadOnly)
  .nameOverride('disclosure', {
    _component: () => FDBodyText,
    _customProps: {
      size: 'sm',
    },
  }, overrideReadOnly);
